import { Box } from "@mantine/core";
import { AnimatePresence, motion } from "framer-motion";
import { PlayerType, ThemeType } from "../util/types";
import DynamicText from "./DynamicText";
import PlayerBadges from "./PlayerBadges";
import PlayerReminder from "./PlayerReminder";
import { useEffect, useState } from "react";

type ShowCardsProps = {
  theme: ThemeType;
  round: string;
  instructions: string;
  cards: string[];
  reminder: string;
  players?: PlayerType[];
  judge?: string;
  onRenderComplete?: () => void;
};

const ShowCards = ({
  theme,
  round,
  instructions,
  cards,
  reminder,
  players,
  judge,
  onRenderComplete = async () => {},
}: ShowCardsProps) => {
  const cardSize = { width: "calc(12vw)", height: "calc(16vw)" };
  const [visibleCards, setVisibleCards] = useState<string[]>(cards);
  useEffect(() => {
    for (let c in cards) {
      if (!visibleCards.includes(cards[c])) {
        setVisibleCards((prev) => prev.filter((card) => card !== cards[c]));
      } else {
        setVisibleCards((prev) => [...prev, cards[c]]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards]);
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 40px)",
        textAlign: "center",
        alignItems: "center",
        marginBottom: 20,
        marginTop: 20,
      }}
    >
      <DynamicText
        style={{
          color: theme.ButtonColor,
          fontSize: 15,
        }}
      >
        {round}
      </DynamicText>
      <DynamicText
        style={{
          color: theme.TextColor,
          fontSize: 35,
          marginTop: 50,
        }}
      >
        {instructions}
      </DynamicText>
      <Box
        style={{
          justifyContent: "center",
          alignContent: "center",
          justifyItems: "center",
          alignItems: "center",
          flexWrap: "wrap",
          display: "flex",
          height: "80%",
        }}
      >
        <AnimatePresence>
          {cards.map((c, i) => {
            return (
              <motion.div
                key={c + i + cards.length}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{
                  damping: 10,
                  duration: 0.5,
                  delay: i * 0.5,
                }}
                exit={{ scale: 0, transition: { duration: 0.5, delay: 0 } }}
                onAnimationComplete={async () => {
                  if (i === cards.length - 1) {
                    await onRenderComplete();
                  }
                }}
              >
                <DynamicText
                  style={{
                    border: "2px solid " + theme.TextColor,
                    borderRadius: 15,
                    width: cards.length === 1 ? "calc(18vw)" : cardSize.width,
                    height: cards.length === 1 ? "calc(24vw)" : cardSize.height,
                    alignContent: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyItems: "center",
                    margin: 5,
                    padding: 5,
                    fontSize: 15,
                  }}
                >
                  {c}
                </DynamicText>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </Box>
      <PlayerReminder reminder={reminder} theme={theme} />
      {players && (
        <PlayerBadges
          players={players}
          judge={judge}
          theme={theme}
          allowTwoRows={false}
          showScores
        />
      )}
    </Box>
  );
};

export default ShowCards;
